<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn class="mx-2" fab dark small color="success" @click="$router.go(-1)">
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br /><br />
        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text">{{ title }} <v-btn
            @click="getall()" dark depressed color="success" v-if="!show_alls">Ver todas</v-btn>
          <v-btn @click="getOnlyFavs()" dark depressed color="info" v-if="show_alls">Ver solo favoritas</v-btn>
        </div>
        <div>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Materia
                  </th>
                  <th class="text-center">
                    Clase Sincronica (Vivo)
                  </th>
                  <th class="text-center">
                    Contenido Asincronico (Grabado)
                  </th>
                  <th class="text-center">
                    Google Drive
                  </th>
                  <th class="text-left">
                    Acción
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(materiaData,
                  materiaKey) in materias" :key="materiaKey">
                  <td v-if="show_alls || (!show_alls && materiaData.visible == true)">{{ materiaData.materia.Materia }}
                  </td>
                  <td align="center" v-if="show_alls || (!show_alls && materiaData.visible == true)">
                    <v-btn :href="linkMeet(materiaData.code)" small
                      class="info--text text-decoration-underline font-weight-regular" depressed text color="info"
                      @click="logPerseverancia()">
                      Ver Aquí
                    </v-btn>
                  </td>
                  <td align="center" v-if="show_alls || (!show_alls && materiaData.visible == true)">
                    <div v-frag v-if="materiaData.ruta">
                      <v-btn @click="linkVideo(materiaData.uuid, materiaData.materia.IDStB), logPerseverancia()" small
                        class="info--text text-decoration-underline font-weight-regular" depressed text color="info">Ver
                        Aquí</v-btn>
                    </div>
                    <div v-frag v-else>
                      <b class="text-center">Sin contenido aún</b>
                    </div>
                  </td>
                  <td align="center" v-if="show_alls || (!show_alls && materiaData.visible == true)">
                    <v-btn v-if="materiaData.google_drive != null" :href="materiaData.google_drive" target="_blank" small
                      class="info--text text-decoration-underline font-weight-regular" depressed text color="info"
                      @click="logPerseverancia()">
                      Ver Aquí
                    </v-btn>
                    <div v-frag v-else>
                      <b class="text-center">Sin contenido aún</b>
                    </div>
                  </td>
                  <td v-if="show_alls || (!show_alls && materiaData.visible == true)">
                    <div v-frag>
                      <v-btn v-if="materiaData.visible == 1" @click="
                        hide2(
                          materiaData.id
                        )
                        " title="Ocultar" depressed text color="Colorsuccess">
                        <v-icon dark>mdi-star</v-icon>
                      </v-btn>
                      <v-btn v-else @click="
                        show2(
                          materiaData.id
                        )" title="Mostrar" depressed text color="Colorsuccess">
                        <v-icon dark>mdi-star-outline</v-icon>
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <br /><br />
        </div>
      </v-col>

      <!-- <v-dialog
      v-model="ganoBadge"
      width="auto"
      >
        <v-card>
          <v-card-title
          class="headline"
          primary-title
        >
          ¡Felicidades! ¡Continúa así...!
        </v-card-title>
          <v-card-text class="mt-3 text-center d-flex flex-column justify-center align-center">
           Has ganado el siguiente reconocimiento:

           <v-img class="mt-4" :aspect-ratio="16 / 9" title="Premio Perseverancia: ¡3 días seguidos estudiando!" width="150" contain
                    :src="require('../../assets/medal.png')"></v-img>

          </v-card-text>
        <v-card-actions>
            <v-btn color="primary" block @click="ganoBadge = false">Cerrar</v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog> -->
    </CardIeaAppMain>
    <v-dialog v-model="ganoBadge" width="auto">
      <v-card>
        <v-card-title class="headline" primary-title>
          ¡Felicidades! ¡Continúa así...!
        </v-card-title>
        <v-card-text class="mt-3 text-center d-flex flex-column justify-center align-center">
          Has ganado el siguiente reconocimiento por haber ingresado {{ dias }} seguidos a la plataforma:

          <v-img class="mt-4" :aspect-ratio="16 / 9" width="150" contain
            :src="require('../../assets/' + imgBadge + '.png')"></v-img>

        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="ganoBadge = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "MisMaterias",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: () => ({
    title: "Mis materias",
    materias: [],
    show_alls: false,
    ganoBadge: false,
    imgBadge: 'bronce',
    dias:3
  }),
  computed: {
    tieneBadge1() {
      return this.$store.getters.tieneBadge1;
    },
    tieneBadge2() {
      return this.$store.getters.tieneBadge2;
    },
    tieneBadge3() {
      return this.$store.getters.tieneBadge3;
    },
    porcentaje1(){
      return this.$store.getters.porcentaje1;
    },
    porcentaje2(){
      return this.$store.getters.porcentaje2;
    },
    porcentaje3(){
      return this.$store.getters.porcentaje3;
    }
  },
  methods: {
    async logPerseverancia() {

      await this.$API.get({
        url: "alumno/setperseverancia"
      }, false).then(res => {
        if (!res.tieneBadge1) {
          if (res.registraBadge1) {
            this.imgBadge='bronce2'
            this.$store.commit('tieneBadge1', res.registraBadge1)
            this.$confetti.start();
            this.ganoBadge = true
            this.dias=3
            setTimeout(() => {
              this.$confetti.stop();
            }, 3000);
          }
        }

        if (!res.tieneBadge2) {
          if (res.registraBadge2) {
            this.imgBadge='plata2'

            this.$store.commit('tieneBadge2', res.registraBadge2)
            this.$confetti.start();
            this.ganoBadge = true
            this.dias=5
            setTimeout(() => {
              this.$confetti.stop();
            }, 3000);
          }
        }

        if (!res.tieneBadge3) {
          if (res.registraBadge3) {
            this.imgBadge='oro2'
            this.$store.commit('tieneBadge3', res.registraBadge3)
            this.$confetti.start();
            this.ganoBadge = true
            this.dias=10
            setTimeout(() => {
              this.$confetti.stop();
            }, 3000);
          }
        }
        this.$store.commit('porcentaje1', res.porcentaje1)
        this.$store.commit('porcentaje2', res.porcentaje2)
        this.$store.commit('porcentaje3', res.porcentaje3)


      });

    },
    linkMeet(code) {
      return 'https://meet.google.com/' + code;
    },

    async hide(id) {
      this.materias = null;
      await this.$API
        .post({
          url: "materia/setvisible",
          data: {
            id: id,
            visible: 0
          }
        }).then(res => {
          console.log(res)
          this.getallData();
        });
    },

    async show(id) {
      this.materias = null;
      await this.$API
        .post({
          url: "materia/setvisible",
          data: {
            id: id,
            visible: 1
          }
        }).then(res => {
          console.log(res)
          this.getallData();
        });
    },

    async show2(id) {
      // this.materias = null;
      await this.$API
        .post({
          url: "materia/setvisible",
          data: {
            id: id,
            visible: 1
          }
        }).then(res => {
          console.log(res)
          const found = this.materias.find(element => element.id == id);
          found.visible = 1;
        });
    },

    async hide2(id) {
      // this.materias = null;
      await this.$API
        .post({
          url: "materia/setvisible",
          data: {
            id: id,
            visible: 0
          }
        }).then(res => {
          console.log(res)
          const found = this.materias.find(element => element.id == id);
          found.visible = 0;
        });
    },
    getall() {
      this.show_alls = true;
    },
    getOnlyFavs() {
      this.show_alls = false;
    },

    async getallData() {
      this.$API
        .get({
          url: "materias",
          data: {}
        })
        .then(res => {
          console.log(res)
          this.materias = res;
        });
    },
    linkVideo(catedra, planestudio) {
      this.$router.push({
        name: "MateriaCodigoClaseVideoAuth",
        params: {
          catedra: catedra,
          planestudio: planestudio
        }
      });
    },
  },

  mounted() {
    if (this.$store.getters.user.borrado == 1 || this.$store.getters.user.alumno_mora == true) {
      this.$router.push({
        name: "Home"
      });
    }
    this.$API
      .get({
        url: "materias",
        data: {}
      })
      .then(res => {
        console.log(res)
        this.materias = res;
      });
  },
};
</script>
